import { sendGTMEvent } from '@next/third-parties/google'

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || ''

export const sendEvent = (event: string, value: string) => {
  if (typeof window !== 'undefined' && GTM_ID) {
    sendGTMEvent({ event, value })
  }
}
